import { HashRouter,Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import Properties from './pages/Properties';
import PropertiesRMs from './pages/PropertiesRMs';
import ResidentManager from './pages/ResidentManager';
import Tenants from './pages/Tenants';
import Units from './pages/Units';


const App = () => {
  return (
  
    <HashRouter>
      <Routes>
        <Route path='/' exact element={<HomePage/>} />
        <Route path='/properties' exact element={<Properties/>} />
        <Route path='/tenants' exact element={<Tenants/>} />
        <Route path='/residentmanager' exact element={<ResidentManager/>} />
        <Route path='/propertiesrms' exact element={<PropertiesRMs/>} />
        <Route path='/units' exact element={<Units/>} />
      </Routes>
    </HashRouter>
          
   
     
  );
}

export default App;
